export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "Administracja": "",
        "Administratorzy": "",
        "Adres e-mail potwierdzony": "",
        "Aktywacja kont po rejestracji": "",
        "Aktywne": "",
        "Aktywni": "",
        "Archiwizuj": "",
        "Asystent AI": "",
        "Autor szkolenia": "",
        "Azure": "",
        "Banery": "",
        "Baza dokumentów": "",
        "Baza ogłoszeń": "",
        "Baza PDF": "",
        "Blokada konta do": "",
        "Błąd w kolumnie ${error.columnName} w wierszu ${error.actualRow} - ${error.error}": "",
        "Brak kategorii": "",
        "Chat z raportami szkoleń": "",
        "Cykliczne": "",
        "Czy opublikowany": "",
        "Data dodania": "",
        "Data modyfikacji": "",
        "Data rejestracji": "",
        "Dodaj szkolenie": "",
        "Dodaj użytkownika": "",
        "Dostęp ": "",
        "Dostęp do": "",
        "Dostęp od": "",
        "Działania masowe": "",
        "E-learning": "",
        "E-mail": "",
        "Edytuj": "",
        "Eksport": "",
        "Email": "",
        "Email potwierdzony": "",
        "Erecruiter": "",
        "Facebook": "",
        "Forum": "",
        "Funkcjonalności AI": "",
        "Gazetka": "",
        "Google": "",
        "Hasło": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Import": "",
        "Import szkoleń": "",
        "Import użytkowników": "",
        "Indywidualny": "",
        "Indywidualny z terminu spotkań": "",
        "Inspekcja": "",
        "Kategoria": "",
        "Komentarze": "",
        "Konto aktywne": "",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
        "Konto z dostępem do panelu": "",
        "Konto zanonimizowane": "",
        "Kreator Szkoleń AI": "",
        "Ldap": "",
        "Liczba zaimportowanych użytkowników: ${importInformations?.importedAccounts}": "",
        "Lider/koordynator dla wszystkich zespołów": "",
        "Linki wewnętrzne": "",
        "Lokalne": "",
        "Marketing": "",
        "Moduły": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Narzędzia AI": "",
        "Nazwa stanowiska": "",
        "Nazwa szkolenia": "",
        "Nazwa użytkownika": "",
        "Nazwisko": "",
        "Nie": "",
        "Nie można usunąć swojego konta.": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy stanowisk": "",
        "Nie udało się pobrać listy zespołów do których jest przypisany użytkownik": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nieaktywni": "",
        "Nieopublikowane": "",
        "Niepotwierdzeni": "",
        "Niepubliczne": "",
        "Nieudane logowania": "",
        "Numer pracownika": "",
        "Numer telefonu": "",
        "Numer telefonu komórkowego": "",
        "Oferty pracy - Import": "",
        "Ogólne": "",
        "Ok": "",
        "OpenAI": "",
        "Opublikowane": "",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "",
        "Podgląd": "",
        "Pole \"Email\" jest wymagane.": "",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "",
        "Pole nie może zawierać spacji": "",
        "Polubienia": "",
        "Potwierdzenie archiwizacji": "",
        "Potwierdzenie przywrócenia szkolenia": "",
        "Potwierdzenie usunięcia": "",
        "Powrót": "",
        "Powtórz hasło": "",
        "Pozostałe": "",
        "Pozycja": "",
        "Przefiltrowani użytkownicy": "",
        "Przywróć": "",
        "Publiczne": "",
        "Ranga": "",
        "Raporty": "",
        "Regulaminy": "",
        "Rezerwacja zasobów": "",
        "Rola": "",
        "Role użytkownika": "",
        "Rotatory opinii": "",
        "RSS": "",
        "Spotkania": "",
        "Stan": "",
        "Stanowisko pracy": "",
        "Stanowisko zostało dodane.": "",
        "Stanowisko zostało zaktualizowane.": "",
        "Status": "",
        "Strona": "",
        "Subskrypcje": "",
        "Synchronizacja użytkowników": "",
        "System": "",
        "Szablon importu": "",
        "Szkolenia": "",
        "Szkolenie zostało przywrócone.": "",
        "Szkolenie zostało zarchiwizowane.": "",
        "Szkolenie zostało zarchiwizowane. Aby je wyświetlić, należy przywrócić szkolenie z archiwum.": "",
        "Ta opcja dodaje użytkownika do wszystkich zespołów z zaznaczoną opcją Lidera i pozwala koordynatorowi widzieć wszystko w profilu koordynatora. Również do nowo utworzonych zespołów będzie  on ustawiał się jako Lider.": "",
        "Tak": "",
        "Tokeny": "",
        "Top tematy": "",
        "Typ": "",
        "Typ konta": "",
        "Uprawnienia": "",
        "Ustawienia": "",
        "Ustawienia generowania streszczeń": "",
        "Ustawienia konta": "",
        "Usuń": "",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "",
        "Użytkownik posiada pełne uprawnienia": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został zaktualizowany.": "",
        "Widoczność konta": "",
        "Wiersz ${error.actualRow}: błąd w kolumnie ${error.columnName} - ${error.error}": "",
        "Wszyscy użytkownicy": "",
        "Wszystkie": "",
        "Wybierz przełożonego": "",
        "Wyłączone wysyłanie powiadomień": "",
        "Wymuś zmianę hasła": "",
        "Wystąpił błąd archiwizacji": "",
        "Wystąpił błąd podczas próby exportu użytkowników.": "",
        "Wystąpił błąd podczas próby importu szkoleń.": "",
        "Wystąpił błąd podczas próby importu użytkowników.": "",
        "Wystąpił błąd podczas próby pobrania szablonu.": "",
        "Wystąpił błąd podglądu": "",
        "zacznij pisać aby wyszukać przełożonego...": "",
        "Zaimportowano listę użytkowników.": "",
        "Zaimportowano szkolenia.": "",
        "Zamknij": "",
        "Zamknij i pobierz": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zarchiwizowane": "",
        "Zastępstwa": "",
        "Zdjęcie użytkownika": "",
        "Zespoły": "",
        "Zespół": "",
        "Zwykłe": ""
    }
};
